/* @minVersion 7.0.0-beta.0 */

export default function _interopRequireDefault(obj: any) {
  return obj && obj.__esModule ? obj : { default: obj };
}
